import { logout, getAuthToken, getUserId } from './auth';

const getAuthHeaders = (token) => ({
  Authorization: 'Bearer ' + token,
});

export const METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

class Api {
  constructor(apiBaseUrl) {
    this.apiBaseUrl = apiBaseUrl;
  }

  async fetch(method, url, queries, headers, body = null, signal) {
    const bodyObj = body && { body: JSON.stringify(body) };
    const idToken = await getAuthToken();
    const userId = await getUserId();
    const authHeaders = getAuthHeaders(idToken);
    const queryString = new URLSearchParams({ userId, ...queries }).toString();

    return fetch(`${this.apiBaseUrl}${url}?${queryString}`, {
      method,
      headers: {
        ...authHeaders,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Web-Version': import.meta.env.VITE_WEB_VERSION,
        ...headers,
      },
      ...bodyObj,
      ...signal,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }

        return res
          .json()
          .catch(() => Promise.reject(res))
          .then((json) => Promise.reject(json));
      })
      .catch((err) => {
        if (err.status === 401) {
          logout();
        }
        if (err.name === 'AbortError') {
          return;
        }
        throw err;
      });
  }

  get(...args) {
    return this.fetch(METHODS.GET, ...args);
  }

  post(...args) {
    return this.fetch(METHODS.POST, ...args);
  }

  put(...args) {
    return this.fetch(METHODS.PUT, ...args);
  }

  delete(...args) {
    return this.fetch(METHODS.DELETE, ...args);
  }
}

const api = new Api(import.meta.env.VITE_API_BASE_DOMAIN);
const optimiseApi = new Api(import.meta.env.VITE_API_OPTIMISE_DOMAIN);

export default api;
export { optimiseApi };
